// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__mVvOv","active":"Pagination_active__q3h4d","isMore":"Pagination_isMore__nARaP"};